module.exports = __webpack_public_path__ + "static/media/part-17.f896118d.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/gallery/part-17.jpg
// module id = 950
// module chunks = 0